import { render } from "./leftblock.vue?vue&type=template&id=3c7a4dc3"
import script from "./leftblock.vue?vue&type=script&lang=js"
export * from "./leftblock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__